module.exports = __webpack_public_path__ + "static/media/Turkey-logo_06.88272445.jpg";